export const NOTIFY_TYPES = {
  addFriend: 1, // 添加好友请求
  respFriend: 2, // 添加好友的响应
  respInvite: 3, // 邀请进入房间/频道的请求
  invite: 4, // 邀请进入房间/频道的响应
  feedback: 5, // 反馈消息回复
  promise: 6, // 邀约请求
  promise_time: 7, // 邀约时间提醒
  system_notification: 10, // 系统通知 
  apply_enter_room: 11, // 向其他用户申请加入房间|频道
  receive_apply_enter_room: 12, // 其他用户向你申请加入房间|频道
  nv_vsync: 13, // 关闭n卡垂直同步
  request_join_room: 14, // 请求 加入需要加入审批的房间
  receive_request_join_room: 15, // 收到请求 加入需要加入审批的房间
  room_anc_at: 16, // 房间公告@

  withAvatarList: [1, 2, 3, 4, 6], // 通知中含有头像的list
  withoutRightText: [8], // 通知中没有右侧按钮or文字的list

  // 前端自用的NOTIFY_TYPES，从90001开始，防止和后端的NOTIFY_TYPES冲突
  team_push: 90001,
}

/**
 * 小黑盒的官方消息是一个大entry
 * 底下有很多sub_entry
 * entry = official_msg
 * sub_entry = friend_interaction
 * 才能锚定成黑盒语音的消息通知
 */

/**
 * 最近消息的entry
 */
export const RECENT_MESSAGE_ENTRY = {
  /**
   * 私信
   */
  message: "message",
  /**
   * 群聊
   */
  chat_group: "chat_group",
  /**
   * 黑盒语音系统消息
   */
  heychat_sys_notify: "heychat_sys_notify",
  /**
   * 黑盒语音互动消息
   */
  heychat_interaction_msg: "heychat_interaction_msg",
  /**
   * 消息通知
   */
  official_msg: "official_msg_v2",
}

/**
 * 最近消息的sub_entry
 */
export const RECENT_MESSAGE_SUB_ENTRY = {
  /**
   * 小黑盒： 好友互动 
   * 黑盒语音： 消息通知
   */
  friend_interaction: "heychat", // 消息通知
}

/**
 * 新的官方消息id
 */
export const NEW_OFFICIAL_MESSAGE_ID = {
  /**
   * 小黑盒： 好友互动 
   * 黑盒语音： 消息通知
   * 黑盒语音消息通知新id
   */
  heybox_message_notify: 13,
  /**
   * 黑盒语音： 系统消息
   */
  heychat_sys_notify: 14,
  /**
   * 黑盒语音： 互动消息
   */
  heychat_interaction_msg: 15,
}

/**
 * 最近消息搜索key常量
 */
export const RECENT_MESSAGE_KEY = {
  /**
   * 联系人
   */
  contact: 'contact',
  /**
   * 群聊
   */
  chat_group: 'chat_group',
  /**
   * 聊天记录
   */
  message: 'message',
}

/**
 * 消息搜索name中文常量
 */
export const CN_RECENT_MESSAGE_SEARCH_NAME = {
  [RECENT_MESSAGE_KEY.contact]: "联系人",
  [RECENT_MESSAGE_KEY.chat_group]: "群聊",
  [RECENT_MESSAGE_KEY.message]: "聊天记录",
}

/**
 * 消息搜索类型常量
 */
export const RECENT_MESSAGE_SEARCH_TYPE = {
  [RECENT_MESSAGE_KEY.contact]: 'contact',
  [RECENT_MESSAGE_KEY.chat_group]: 'group',
  [RECENT_MESSAGE_KEY.message]: 'message',
}

export const DEFAULT_NOTIFY_TYPES = {
  all_messages: '1', // 通知所有消息
  only_at: '2', // 仅@被提及
  no_notify: '3' // 无通知
}

export const NOTICE_TYPE_TEXT = {
  '1': '所有消息',
  '2': '仅@被提及',
  '3': '无通知',
}

/**
 * 归档 旧版本官方消息ID
 * @deprecated 请使用 NEW_OFFICIAL_MESSAGE_ID 代替
 */
export const OFFICIAL_NOTIFY_TYPES = {
  official_msg: 1, // 系统消息 NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify
  request_msg: 2, // 消息通知 NEW_OFFICIAL_MESSAGE_ID.heybox_message_notify
  post_msg: 3, // 互动消息 NEW_OFFICIAL_MESSAGE_ID.heychat_interaction_msg
}

export const NOTIFY_RESP = {
  NO_RESP: 0, // 发送后还未处理
  APPLT: 1, // 接受
  REJECT: 2, // 拒绝
  WAIT: 3, // 等待验证
  DESTROYED: 4, // 已销毁，开黑邀约被关闭时为4
  APPLY_RESP: 5, // 对方接受后，我方接受（接受回应）
  REJECT_RESP: 6, //  对方接受后，我方拒绝（拒绝回应）
}

export const OFFICAL_MSG_BASIC = {
  nickname: '系统消息',
  avatar: 'https://imgheybox.max-c.com/oa/2023/09/01/fc1608e266597a785238a46b6a995a95.png',
  user_id: NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify,
}

export const POST_MSG_BASIC = {
  nickname: '互动消息',
  avatar: 'https://imgheybox.max-c.com/oa/2024/04/17/4a9557fd91bbc33267d56c4e79d01638.png',
  user_id: NEW_OFFICIAL_MESSAGE_ID.heychat_interaction_msg,
}

export const ON_RISK_IMG_URL = 'https://imgheybox.max-c.com/oa/2024/08/16/8e75cf17e5df11ac3900d8c362fada90.png'